(() => {
  if (!window.matchMedia || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.wk-home :is(.wk-section-head, .wk-community__intro, .wk-community__numbers, .wk-community__reviews, .wk-promise-panel, .wk-quarantine__routes > article, .wk-delivery, .wk-discover__intro, .wk-food-story, .wk-film--story .wk-film__content, .wk-delivery-art)';
  const seen = new WeakSet();
  const running = new Map();
  let observer;

  const stop = () => {
    observer?.disconnect();
    observer = undefined;
    running.forEach(animation => animation.cancel());
    running.clear();
  };

  const start = (root = document) => {
    if (preference.matches || window.Shopify?.designMode || navigator.connection?.saveData) return;
    if (!observer) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const element = entry.target;
          observer?.unobserve(element);
          if (seen.has(element)) return;
          seen.add(element);
          if (preference.matches || element.contains(document.activeElement)) return;
          const animation = element.animate(
            [{ opacity: .65, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }],
            { duration: 480, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'none' }
          );
          running.set(element, animation);
          animation.finished.catch(() => {}).finally(() => running.delete(element));
        });
      }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
    }
    root.querySelectorAll(selector).forEach(element => {
      if (!seen.has(element)) observer.observe(element);
    });
  };

  document.addEventListener('focusin', event => {
    running.forEach((animation, element) => {
      if (element.contains(event.target)) animation.cancel();
    });
  });
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', stop);
  preference.addEventListener('change', () => { stop(); start(); });
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', () => start());
  start();
})();
